import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { setDialogInfo, setTvWallCameras } from '../../redux/traffic-live';
var TvWallCart = /*#__PURE__*/React.memo(function () {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      tvWallCameras = _useSelector.trafficLive.tvWallCameras;

  var dispatch = useDispatch();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      cameraCount = _useState2[0],
      setCameraCount = _useState2[1];

  useEffect(function () {
    if (tvWallCameras.length === 0) return setCameraCount();
    var count = 0;
    tvWallCameras.map(function (el) {
      if (!_.isEmpty(el)) count++;
    });
    setCameraCount(count);
  }, [JSON.stringify(tvWallCameras)]);

  var isShowCartIcon = function isShowCartIcon() {
    if (tvWallCameras.length === 0) return false;

    for (var i = 0; i < tvWallCameras.length; i++) {
      if (!_.isEmpty(tvWallCameras[i])) return true;
    }

    return false;
  };

  var openTvWallDialog = function openTvWallDialog(e) {
    e.preventDefault();
    dispatch(setDialogInfo({
      mode: 'tvWall'
    }));
  };

  var clearAllTvWallCameras = function clearAllTvWallCameras(e) {
    e.preventDefault();
    dispatch(setTvWallCameras([]));
  };

  if (!isShowCartIcon()) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "tvwall-cart"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-times clear",
    onClick: clearAllTvWallCameras
  }), /*#__PURE__*/React.createElement("div", {
    className: "cart",
    onClick: openTvWallDialog
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-desktop desktop"
  }), /*#__PURE__*/React.createElement("div", {
    className: "count"
  }, cameraCount), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, "Tv Wall")));
});
export default TvWallCart;